export function decrypt(key) {
    const num = parseInt(key[0])
    return key.substr(key.length - num)
}